import { Box, Skeleton, Typography, useTheme } from "@mui/material";
import { styled } from "@mui/system";
import LabeledBarChart from "components/Chart/LabeledBarChart";
import { memo, useEffect, useState } from "react";
import { apiGetProfitAndLoss } from "../../api/dashboardApi";
import { BoxUpper } from "../Shared/BoxUpper";
import { BoxBodyContainer, RawBox } from "../Shared/Dashboard/styled";
import getCurrency from "helpers/currencyHelper";
import { useAppDispatch, useAppSelector } from "store/store";
import RefreshIcon from "assets/icons/RefreshIcon";

const FlexBox = styled("div")({
  display: "flex",
});
const UpperSectionContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "100%",
});
const LowerSectionContainer = styled("div")({
  // backgroundColor: '#3800003b',
  gridTemplateColumns: "repeat(auto-fill, 40%)",
  justifyContent: "space-around",
  gridGap: "15px",
});
const StyledBoxBodyContainer = styled(BoxBodyContainer)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
});

const options = [
  { label: "کل سال مالی", value: "lastYear", id: 1 },
  { label: "شش ماه اخیر", value: "lastSixMonth", id: 2 },
  { label: "ماه اخیر", value: "lastMonth", id: 3 },
  { label: "هفته اخیر", value: "lastWeek", id: 4 },
];

const ProfitAndLoss = ({ title }: { title?: string }) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const token = useAppSelector((x) => x.businessReducer.business.token);
  const profitAndLoss = useAppSelector((x) => x.dashboardReducer.profitAndLoss) as ProfitAndLossDataType;

  // useEffect(() => {
  //   if (token) {
  //     dispatch(apiGetProfitAndLoss(token));
  //   }
  // }, [token]);

  const data =
    profitAndLoss && profitAndLoss.information
      ? profitAndLoss.information.map((item) => ({
        percent: Math.abs(item.totalPrice),
        title: item.title,
      }))
      : [];

  const handleChange = (filterType: string) => {
    dispatch(apiGetProfitAndLoss(token, filterType,changeLoading));
  };

  const [isLoading, setLoading] = useState(false)
  const changeLoading = () => {
    setLoading(state => !state)
  }
  return <RawBox>
    <BoxUpper onChange={handleChange} options={options} title={title} />
    <StyledBoxBodyContainer>
      <UpperSectionContainer>
        <FlexBox>
          <Typography
            color={theme.palette.text.primary}
            style={{ direction: "ltr" }}
            fontWeight="bold"
            variant="h5"
          >
            {Intl.NumberFormat().format(profitAndLoss ? profitAndLoss.profit : 0)}
          </Typography>
          <Typography color={theme.palette.disabled.main}>
            &nbsp; {getCurrency().defCur.en_title}
          </Typography>
        </FlexBox>
        <Typography color={theme.palette.disabled.main}>{/* ۰۰/۲/۳ */}</Typography>
      </UpperSectionContainer>
      <LowerSectionContainer>
        {data.length > 0 ? (
          <LabeledBarChart data={data} height={290} />
        ) : (
          <Box
            onClick={() => {
              handleChange('lastYear')
            }}
            sx={{
              position: 'relative',
              width: '100%', // Set your desired width
              height: 290, // Set your desired height
              display: 'flex',
              justifyContent: 'center',
              cursor: 'pointer',
              alignItems: 'center',
              // border: '1px solid #ccc', // Optional: for visual reference
            }}
          >
            <Skeleton variant="rectangular" width={"100%"} height={"100%"} />
            <Typography
              variant="h6"
              sx={{
                position: 'absolute',
                color: '#747575', // Change color based on your skeleton background
              }}
            >
              نمایش نمودار
            </Typography>
            <div className={`absolute bottom-[35%] ${isLoading ? "animate-spin" : ""}`}>
                  <RefreshIcon scale={0.8} />
                </div>

          </Box>
        )
        }
      </LowerSectionContainer>
    </StyledBoxBodyContainer>
  </RawBox>


};

const PriceItemContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  padding: "15px 24px",
});

const PriceItem = ({ title, price, color }: { title?: string; price?: string; color?: string }) => {
  const theme = useTheme();
  return (
    <PriceItemContainer>
      <Typography color={color}>{title}</Typography>
      <Box sx={{ padding: "5px" }} />
      <FlexBox>
        <Typography variant="h6">{price}</Typography>
        <Typography color={theme.palette.disabled.main}>&nbsp; {getCurrency().defCur.en_title}</Typography>
      </FlexBox>
    </PriceItemContainer>
  );
};

export default memo(ProfitAndLoss);
